import styled, { css } from 'styled-components';
import { modalCloseButton } from '../../../theme/modalClose';

export const Closer = styled.div``;

export const StyledModal = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(50, 59, 75, 0.1);
  backdrop-filter: blur(4px);
  padding: 20px;
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  opacity: ${({ open }) => (open ? '1' : '0')};
  transition: 0.3s all ease-in-out;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  color: var(--text-color);
`;

export const ContentHolder = styled.div`
  max-width: ${({ width }) => (width ? `${width}px` : '100%')};
  width: ${({ width }) => (width ? '100%' : '')};
  padding: ${({ padding }) => padding ?? '25px'}; // must prop
  background: ${({ bg }) => bg ?? ''}; // must props
  border-radius: ${({ radius }) => radius ?? '10px'};
  animation: myAnim 0.3s ease;
  background: var(--white);
  /* Never taller than the screen (the overlay has 20px padding each side); long
     content scrolls inside. A percentage max-height is not reliably resolved here,
     which let a long modal grow off the top and bottom of the screen. */
  box-sizing: border-box;
  max-height: calc(100vh - 40px);
  max-height: calc(100dvh - 40px);
  overflow-y: auto;
  /* Centred, but still reachable from the top if it ever overflows. */
  margin: auto;

  html.dark & {
    background: var(--hd-card);
  }

  @keyframes myAnim {
    0% {
      opacity: 0;
      transform: scale(0.5);
    }

    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const Head = styled.div`
  width: 100%;
  min-height: 40px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 50px;
  margin-bottom: ${({ $headerMarginBottom }) => $headerMarginBottom ? $headerMarginBottom : '30px'};

  .closer {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    width: 40px;
    border: 1px solid rgba(246, 248, 250, 1);
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--dark);
    padding: 0;
  }

  ${({ newStyle }) =>
    newStyle &&
    css`
      padding-bottom: 0;
      margin-bottom: 0;

      .closer {
        width: auto;
        height: auto;
        border: none;
        transform: none;
        top: 0;
      }
    `}

  .title {
    font-size: 24px;
    line-height: 28px;
    font-weight: 700;
    color: var(--text-color-50);
  }
  .subtitle {
    font-size: 20px;
    font-weight: 400;
    line-height: 40px;
  }

  .Icon {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 500px) {
    .closer {
      width: 30px;
      height: 30px;
    }

    .title {
      font-size: 20px;
      font-weight: 400;
    }
  }
  /* Same close button as every other modal (theme/modalClose). */
  .closer {
    ${modalCloseButton}
  }

`;
